export default __webpack_public_path__ + "static/media/Audit.bca8190b.svg";